import React from 'react';
import style from './checklistItem.scss';
import getStepTitle from '../../../services/helper/stepTitle';

export default function ChecklistItem(props) {

    const { name, isActive, isDone } = props;

    let itemClass = style.item;
    let dotClass = style.dot;
    if (isDone) {
        itemClass = style.item__done;
        dotClass = style.dot__done;
    } else if (isActive) {
        itemClass = style.item__active;
        dotClass = style.dot__active;
    }

    return (
        <div className={style.container}>
            <div className={itemClass}>
                <div className={style.title}>
                    {getStepTitle(name)}
                </div>
                <div className={dotClass} />
            </div>
        </div>
    );
}
